'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

___$insertStyle("/*\n* ink colors (with variations only for black and white)\n*/\n.dm-root {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 0;\n  background-color: #fff;\n  width: 248px;\n  height: 100vh;\n  position: fixed;\n  left: 0;\n  top: 0;\n  transition-duration: 0.25s;\n  transition-property: all;\n  transform: translateX(-105%);\n  box-shadow: 0px 2px 8px 0px rgba(0, 58, 109, 0.16);\n}\n@media (min-width: 1200px) {\n  .dm-root {\n    display: block;\n    flex-grow: 1;\n    width: auto;\n    height: auto;\n    position: relative;\n    transform: none;\n    box-shadow: none;\n  }\n}\n.dm-root.is-open {\n  transition-duration: 0.5s;\n  transform: translateX(0);\n}\n.dm-root .ul, .dm-root .ul_parent {\n  list-style-type: none;\n  display: flex;\n  margin: 0;\n  padding: 0;\n}\n.dm-root .ul_parent {\n  flex-direction: column;\n  width: 100%;\n}\n@media (min-width: 1200px) {\n  .dm-root .ul_parent {\n    flex-direction: row;\n  }\n}\n\n.dm-root-header {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  height: 48px;\n  padding-left: 16px;\n}\n@media (min-width: 1200px) {\n  .dm-root-header {\n    display: none;\n  }\n}\n\n.dm-root-body {\n  overflow-y: auto;\n  display: block;\n  flex-grow: 1;\n  width: 100%;\n}\n@media (min-width: 1200px) {\n  .dm-root-body {\n    overflow-y: visible;\n  }\n}");
//# sourceMappingURL=DesktopMenu.scss.js.map
